import React, { useEffect } from "react";
import "./mystaking.scss";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useWeb3React } from "@web3-react/core";
import Datatable from "./DataTable/Datatable";
import { Offcanvas, Pagination } from "react-bootstrap";
import { TomiAllowance } from "../../hooks/allowence";
import { GetBalance } from "../../hooks/getBalance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import environment from "../../utils/Enviroment";
import { getStackContract } from "../../utils/contractHelpers";
import { ApproveAllow } from "../../hooks/approvedAllowence";
import useWeb3 from "../../hooks/useWeb3";
import { getdopTokenContract } from "../../utils/contractHelpers";
import axios from "axios";
import Timer from "./Timer";
import StakingTable from "./DataTable/Datatable";
import Loader from "../../hooks/loader";
import Web3 from "web3";

const Mystaking = ({
  indexwaits,
  indexwait,
  openmodal,
  setOpenmodal,
  setShow111,
}) => {
  var currencyFormatter = require("currency-formatter");
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const { GetBal } = GetBalance();
  const [balanceOf, setBalanceOf] = useState("");
  // console.log("balance here ", balanceOf)
  const { AllowanceTomi } = TomiAllowance();
  const [allowance, setAllowance] = useState("");
  const [errormessage, seterrormessage] = useState("");
  // console.log("balance here ", allowance)
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [MyDopBalance, setMyDopBalance] = useState("");
  const [MyDopBalanceactive, setMyDopBalanceactive] = useState("");
  const [MyDopBalanceTotalhere, setMyDopBalanceTotalhere] = useState("");
  var rewardPerYear = 210000000;
  var apy = (rewardPerYear / MyDopBalanceTotalhere) * 100;
  // console.log("asasas", MyDopBalance)
  const [clamiedrewardss, setclamiedrewardss] = useState("");
  const [clamiedreward, setclamiedreward] = useState("");
  // console.log("datahere is", clamiedreward, clamiedrewardss)
  const [Amountclamiednow, setAmountclamiednow] = useState();
  // console.log("amount claimed", Amountclamiednow)
  const [activeDeposit, setActiveDeposit] = useState([]);
  // console.log("data here", activeDeposit)
  const [valueamount, setvalueamount] = useState();
  const [valueamount1, setvalueamount1] = useState();
  const [unstakedvalue, setunstakedvalue] = useState();
  const [stakedvalue, setstakedvalue] = useState();
  const [Restakedvalue, setRestakedvalue] = useState("");
  const [loader, setLoader] = useState(false);
  const [claimabletime, setclaimabletime] = useState();
  const [timeIsUp, setTimeIsUp] = useState(false);
  const { ApproveTokenAllow } = ApproveAllow();
  const [activeDepositCount, setActiveDepositCount] = useState(1);
  const [mainLoader, setMainLoader] = useState(false);
  const [text, settext] = useState("Loading");

  const [stakegas, setstakegas] = useState("");
  // const [Restakedvalue, setRestakedvalue] = useState("");
  // const [Restakedvalue, setRestakedvalue] = useState("");
  // const [Restakedvalue, setRestakedvalue] = useState("");
  // const [Restakedvalue, setRestakedvalue] = useState("");

  // console.log("is time up", timeIsUp)

  const [show, setShow] = useState(false);
  const handleClose = (stake) => {
    setShow(false);
    setOpenmodal(false);
    if (!stake) {
      setvalueamount("");
    }
  };
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setShow1(false);
    setOpenmodal(false);
    setvalueamount("");
  };
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setOpenmodal(false);
    setstakedvalue("");
  };
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = (unsatk) => {
    setShow3(false);
    if (!unsatk) {
      setvalueamount1("");
    }
  };
  const handleShow3 = () => {
    // console.log("valur herw")
    DopBalanceCheck();
    setShow3(true);
  };

  const [show4, setShow4] = useState(false);
  const handleClose4 = () => {
    setShow4(false);
    setvalueamount1("");
  };
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => {
    setunstakedvalue("");
    setShow5(false);
  };
  const handleShow5 = () => setShow5(true);

  const [show6, setShow6] = useState(false);
  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => {
    ClaimableRewarCheck();
    ClaimableRewarChecks();
    setShow6(true);
  };
  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [show8, setShow8] = useState(false);
  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);

  const [show9, setShow9] = useState(false);
  const handleClose9 = () => setShow9(false);
  const handleShow9 = () => {
    ClaimableRewarCheck();
    ClaimableRewarChecks();
    setShow9(true);
  };

  const [show10, setShow10] = useState(false);
  const handleClose10 = () => setShow10(false);
  const handleShow10 = () => setShow10(true);

  const [show11, setShow11] = useState(false);
  const handleClose11 = () => {
    ClaimableRewarCheck();
    setShow11(false);
  };
  const handleShow11 = () => setShow11(true);

  const [show13, setShow13] = useState(false);
  const handleClose13 = () => {
    setShow13(false);
  };
  const handleShow13 = () => setShow13(true);

  const [show12, setShow12] = useState(false);
  const handleClose12 = () => {
    ClaimableRewarCheck();
    setShow12(false);
  };
  const handleShow12 = () => setShow12(true);

  const getBalance = async () => {
    let result = await GetBal(account);
    // let result2 = await GetHolder()
    // console.log("resulttvl", result2)
    setBalanceOf(result);
  };

  // const handleInputChange = (event) => {
  //   if (event.target.value != "") {
  //     setvalueamount(event.target.value);
  //     setstakedvalue(event.target.value);
  //   } else {
  //     setvalueamount();
  //   }
  // };
  const handleInputChange = (event) => {
    const value = event.target.value;
    // Remove any non-numeric characters from the input value
    const sanitizedValue = value.replace(/[^0-9.]/g, "");
    // Regex to match numbers only (without allowing +, -, e)
    const isValidNumber = /^\d*\.?\d*$/.test(sanitizedValue);

    if (isValidNumber) {
      if (sanitizedValue !== "") {
        setvalueamount(sanitizedValue);
        setstakedvalue(sanitizedValue);
      } else {
        setvalueamount("");
      }
    }
  };

  const handleMaxBal = () => {
    setvalueamount(truncateToFourDecimals(balanceOf));
    setstakedvalue(parseFloat(balanceOf).toFixed(3));
    if (balanceOf > 0) {
    }
  };

  const handleMaxBal1 = () => {
    setvalueamount1(truncateToFourDecimals(MyDopBalance));
    setunstakedvalue(parseFloat(MyDopBalance).toFixed(3));
  };

  const handleInputChange1 = (event) => {
    // console.log("sdsd")
    const value = event.target.value;
    // Remove any non-numeric characters from the input value
    const sanitizedValue = value.replace(/[^0-9.]/g, "");
    // Regex to match numbers only (without allowing +, -, e)
    const isValidNumber = /^\d*\.?\d*$/.test(sanitizedValue);

    if (isValidNumber) {
      if (sanitizedValue !== "") {
        setvalueamount1(sanitizedValue);
        setunstakedvalue(sanitizedValue);
      } else {
        setvalueamount1("");
      }
    }
  };

  const StackingAllowenceCheck = async () => {
    try {
      // setMainLoader(true);
      let result = await AllowanceTomi();
      setAllowance(result);
      // console.log("error allownce get", result);
      // setMainLoader(false);
    } catch {
      console.log("error allownce get");
    }
  };

  const DopBalanceCheck = async () => {
    const contractAddress = environment?.StackContact;
    const contract = getStackContract(contractAddress, web3);
    try {
      // console.log("total");
      const approved = await contract.methods.stakes(account).call();
      // console.log("approved value here", approved)
      const currentTime = Math.floor(Date.now() / 1000);
      if (approved?.claimTime > currentTime) {
        // console.log("value", approved?.amount / 10 ** 18)
        setclaimabletime(approved?.claimTime);
        const dopbal = approved?.amount / 10 ** 18;
        const restakbal = approved?.restakedAmount / 10 ** 18;
        setMyDopBalance(dopbal - restakbal);
        setRestakedvalue(approved?.restakedAmount / 10 ** 18);
        setMyDopBalanceactive(approved?.amount / 10 ** 18);
      } else {
        setMyDopBalance(approved?.amount / 10 ** 18);
        setRestakedvalue(approved?.restakedAmount / 10 ** 18);
        setclaimabletime(approved?.claimTime);
        setMyDopBalanceactive(approved?.amount / 10 ** 18);
      }
    } catch (error) {
      console.log("error allownce get");
    }
    // setMainLoader(false);
  };

  const ClaimableRewarCheck = async () => {
    console.log("every1 minute");
    const contractAddress = environment?.StackContact;
    const contract = getStackContract(contractAddress, web3);
    try {
      // console.log("total");
      const clamieb = await contract.methods.getReward(account).call();
      // console.log("here value",clamieb / 10 ** 18)
      setclamiedreward((clamieb / 10 ** 18).toFixed(3));
    } catch (error) {
      console.log("error allownce get");
    }
    // setMainLoader(false);
  };

  // Use useEffect to run the function every minute
  useEffect(() => {
    // console.log("aaaaaaaa_++++++++++++++++++++++++++")
    const intervalId = setInterval(ClaimableRewarCheck, 60000); // 60000 milliseconds = 1 minute

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [account, indexwaits]);

  const ClaimableRewarChecks = async () => {
    const contractAddress = environment?.StackContact;
    const contract = getStackContract(contractAddress, web3);
    try {
      // console.log("total");
      const clamieb = await contract.methods.getReward(account).call();
      setclamiedrewardss((clamieb / 10 ** 18).toFixed(3));
    } catch (error) {
      console.log("error allownce get");
    }
    // setMainLoader(false);
  };

  function truncateToFourDecimals(number) {
    const factor = Math.pow(10, 6); // 10^6 = 1000000
    return Math.floor(number * factor) / factor;
  }

  const StakeFun = async () => {
    var resultssss = await AllowanceTomi();
    // console.log("allowence", resultssss)

    if (account) {
      try {
        if (
          valueamount <= "" ||
          valueamount === undefined ||
          valueamount <= 0
        ) {
          seterrormessage("Please enter dop value to stake");
          handleShow13();

          // toast.error("Please enter dop value to stake", {
          //   position: "top-center",
          //   autoClose: 5000,
          // });
        } else if (valueamount > balanceOf) {
          seterrormessage("The entered amount exceeds your staked DOP balance");
          handleShow13();
          // toast.error("Selected value must be smaller then your dop balance", {
          //   position: "top-center",
          //   autoClose: 5000,
          // });
        } else if (resultssss >= parseFloat(valueamount) === true) {
          // setMainLoader(true);
          const contractAddress = environment?.StackContact;
          const contract = getStackContract(contractAddress, web3);
          try {
            settext("Confirm Stake Transaction And Wait...");
            setMainLoader(true);
            let value2 = truncateToFourDecimals(valueamount);
            // console.log("vavlue", value2)
            // let amount11 = parseFloat(valueamount).toFixed(5)
            // console.log("float value", amount11)
            // let amount1 = Math.ceil((amount11) * 1e12) / 1e12;
            // console.log("float value", amount1)
            let bal = web3.utils.toWei(value2?.toString(), "ether");
            // console.log("value here is", bal)

            var gasFunPrice;
            web3.eth.getGasPrice().then((result) => {
              var result2 = parseInt(result) + 3000000000;
              gasFunPrice = result2.toString();
            });
            const gas = await contract.methods
              .stake(bal)
              .estimateGas({ from: account });
            const gaslimit = gas + parseInt(15000);
            const balance = await contract.methods
              .stake(bal)
              .send({ from: account, gas: gaslimit, gasPrice: gasFunPrice });
            if (balance) {
              setTimeout(() => {
                setTimeIsUp(false);
                getBalance();
                StackingAllowenceCheck();
                handleClose1();
                DopBalanceCheck();
                getDepositDataAmount();
                getDepositData(currentPage, pageSize);
                handleShow2();
                setMainLoader(false);
                settext("Loading...");
                ClaimableRewarCheck();
                ClaimableRewarChecks();
              }, 1000);
              setvalueamount("");
              StackingAllowenceCheck();
            }
            setvalueamount("");
          } catch (error) {
            setMainLoader(false);
            settext("Loading...");
            if (error.code === -32000) {
              seterrormessage("Insufficient Eth For Fee");
              handleShow13();
              // toast.warning("Insufficient Eth For Fee", {
              //   position: "top-center",
              //   autoClose: 4000,
              // });
              console.log("9999999", error.code);
              throw error;
            } else {
              seterrormessage(error.message);
              handleShow13();
              // toast.error(error.message, {
              //   position: "top-center",
              //   autoClose: 4000,
              // });
              console.log("9999999", error);
              throw error;
            }
          }
        } else {
          if (account) {
            // toast.warning("Please Approve Your Coins First", {
            //   position: "top-center",
            //   autoClose: 4000,
            // });
            if (balanceOf > 0) {
              try {
                settext("Confirm Approve Transaction And Wait...");
                setMainLoader(true);
                var result = await ApproveTokenAllow();
              } catch (error) {
                setMainLoader(false);
                settext("Loading...");
              }
              if (result) {
                // toast.success("Coins Approved Successfully", {
                //   position: "top-center",
                //   autoClose: 4000,
                // });
                let resultss = await AllowanceTomi();
                console.log("allowence", resultss);
                if (valueamount <= resultss) {
                  const contractAddress = environment?.StackContact;
                  const contract = getStackContract(contractAddress, web3);
                  try {
                    settext("Confirm Stake Transaction And Wait...");
                    setMainLoader(true);
                    // let amount11 = parseFloat(valueamount).toFixed(4)
                    let value2 = truncateToFourDecimals(valueamount);
                    // let amount1 = Math.round((amount11) * 1e12) / 1e12;
                    let bal = web3.utils.toWei(value2?.toString(), "ether");
                    console.log("value here is", bal);

                    var gasFunPrice;
                    web3.eth.getGasPrice().then((result) => {
                      var result2 = parseInt(result) + 3000000000;
                      gasFunPrice = result2.toString();
                    });

                    const gas = await contract.methods
                      .stake(bal)
                      .estimateGas({ from: account });
                    const gaslimit = gas + parseInt(15000);

                    const balance = await contract.methods.stake(bal).send({
                      from: account,
                      gas: gaslimit,
                      gasPrice: gasFunPrice,
                    });
                    if (balance) {
                      setTimeout(() => {
                        setTimeIsUp(false);
                        getBalance();
                        StackingAllowenceCheck();
                        handleClose1();
                        DopBalanceCheck();
                        getDepositDataAmount();
                        getDepositData(currentPage, pageSize);
                        handleShow2();
                        setMainLoader(false);
                        settext("Loading...");
                        ClaimableRewarCheck();
                        ClaimableRewarChecks();
                      }, 1000);
                      setvalueamount("");
                      StackingAllowenceCheck();
                    }
                    setvalueamount("");
                  } catch (error) {
                    setMainLoader(false);
                    settext("Loading...");
                    if (error.code === -32000) {
                      seterrormessage("Insufficient Eth For Fee");
                      handleShow13();
                      // toast.warning("Insufficient Eth For Fee", {
                      //   position: "top-center",
                      //   autoClose: 4000,
                      // });
                      console.log("9999999", error.code);
                      throw error;
                    } else {
                      // toast.error(error.message, {
                      //   position: "top-center",
                      //   autoClose: 4000,
                      // });
                      seterrormessage(error.message);
                      handleShow13();
                      // toast.error(
                      //   "execution reverted may be becuase of dop coins you are staking more then your allownce",
                      //   {
                      //     position: "top-center",
                      //     autoClose: 4000,
                      //   }
                      // );
                      console.log("9999999", error);
                      throw error;
                    }
                  }
                } else {
                  setMainLoader(false);
                  seterrormessage(
                    "Your entered amount must be equal or less then your allownce approved"
                  );
                  handleShow13();
                  // toast.error(
                  //   "Your entered value must be equal or less then your allownce approved",
                  //   {
                  //     position: "top-center",
                  //     autoClose: 5000,
                  //   }
                  // );
                }
              }
            } else {
              setMainLoader(false);
              // toast.error("Dop balance must be greater then 0", {
              //   position: "top-center",
              //   autoClose: 5000,
              // });
              seterrormessage("Dop balance must be greater then 0");
              handleShow13();
            }
          } else {
            seterrormessage("Please connect your wallet first to approve");
            handleShow13();
            // toast.error("Please connect your wallet first to approve", {
            //   position: "top-center",
            //   autoClose: 5000,
            // });
          }
        }
      } catch {
        // setMainLoader(false);
      }
    } else {
      seterrormessage("Please Connect Your Wallet First");
      handleShow13();
      // toast.error("Please Connect Your Wallet First", {
      //   position: "top-center",
      //   autoClose: 5000,
      // });
    }
  };

  const UnstakeFun = async () => {
    if (account) {
      try {
        // setMainLoader(true)
        if (valueamount1 <= MyDopBalance) {
          // setMainLoader(true);
          const contractAddress = environment?.StackContact;
          const contract = getStackContract(contractAddress, web3);
          try {
            settext("Confirm Unstake Transaction And Wait...");
            setMainLoader(true);
            // let amount11 = parseFloat(valueamount1).toFixed(4)
            // console.log("value here is",amount11)
            // let amount1 = Math.ceil((amount11) * 1e12) / 1e12;
            // console.log("value here is",amount1)
            let value2 = truncateToFourDecimals(valueamount1);
            // let value1 = parseFloat(valueamount1).toFixed(4)
            let bal = web3.utils.toWei(value2?.toString(), "ether");
            console.log("value here is", bal);

            var gasFunPrice;
            web3.eth.getGasPrice().then((result) => {
              var result2 = parseInt(result) + 3000000000;
              gasFunPrice = result2.toString();
            });

            const gas = await contract.methods
              .requestUnstake(bal)
              .estimateGas({ from: account });

            const gaslimit = gas + parseInt(15000);

            const balance = await contract.methods
              .requestUnstake(bal)
              .send({ from: account, gas: gaslimit, gasPrice: gasFunPrice });
            if (balance) {
              setTimeout(() => {
                getBalance();
                handleClose4();
                DopBalanceCheck();
                handleShow5();
                setvalueamount1("");
                setMainLoader(false);
                settext("Loading...");
                ClaimableRewarCheck();
                ClaimableRewarChecks();
              }, 1000);
            }
          } catch (error) {
            setMainLoader(false);
            settext("Loading...");
            if (error.code === -32000) {
              seterrormessage("Insufficient Eth For Fee");
              handleShow13();
              // toast.warning("Insufficient Eth For Fee", {
              //   position: "top-center",
              //   autoClose: 4000,
              // });
              console.log("9999999", typeof error.code);
              throw error;
            } else {
              seterrormessage(error.message);
              handleShow13();
              // toast.error(error.message, {
              //   position: "top-center",
              //   autoClose: 4000,
              // });
              console.log("9999999", error);
              throw error;
            }
          }
        } else {
          seterrormessage("The entered amount exceeds your staked DOP balance");
          handleShow13();
          // toast.error("Selected value must be smaller then your Staked Dop", {
          //   position: "top-center",
          //   autoClose: 5000,
          // });
        }
      } catch {
        // setMainLoader(false);
      }
    } else {
      seterrormessage("Please Connect Your Wallet First");
      handleShow13();
      // toast.error("Please Connect Your Wallet First", {
      //   position: "top-center",
      //   autoClose: 5000,
      // });
    }
  };

  const RestateFun = async () => {
    ClaimableRewarChecks();
    ClaimableRewarCheck();
    if (account) {
      try {
        // setMainLoader(true);
        const contractAddress = environment?.StackContact;
        const contract = getStackContract(contractAddress, web3);
        try {
          settext("Confirm Restake Transaction And Wait...");
          setMainLoader(true);
          var gasFunPrice;
          web3.eth.getGasPrice().then((result) => {
            var result2 = parseInt(result) + 3000000000;
            gasFunPrice = result2.toString();
          });
          const gas = await contract.methods
            .claimAndRestake()
            .estimateGas({ from: account });
          const gaslimit = gas + parseInt(15000);
          const balance = await contract.methods
            .claimAndRestake()
            .send({ from: account, gas: gaslimit, gasPrice: gasFunPrice });
          if (balance) {
            setTimeout(() => {
              setTimeIsUp(false);
              getBalance();
              DopBalanceCheck();
              getDepositDataAmount();
              getDepositData(currentPage, pageSize);
              handleClose9();
              handleShow10();
              setMainLoader(false);
              settext("Loading...");
              ClaimableRewarCheck();
            }, 1000);
          }
        } catch (error) {
          setMainLoader(false);
          settext("Loading...");
          if (error.code === -32000) {
            seterrormessage("Insufficient Eth For Fee");
            handleShow13();
            // toast.warning("Insufficient Eth For Fee", {
            //   position: "top-center",
            //   autoClose: 4000,
            // });
            console.log("9999999", typeof error.code);
            throw error;
          } else {
            seterrormessage(error.message);
            handleShow13();
            // toast.error(error.message, {
            //   position: "top-center",
            //   autoClose: 4000,
            // });
            console.log("9999999", error);
            throw error;
          }
        }
      } catch {
        // setMainLoader(false);
      }
    } else {
      seterrormessage("Please Connect Your Wallet First");
      handleShow13();
      // toast.error("Please Connect Your Wallet First", {
      //   position: "top-center",
      //   autoClose: 5000,
      // });
    }
  };

  const claimFun = async () => {
    ClaimableRewarCheck();
    ClaimableRewarChecks();
    if (account) {
      try {
        // setMainLoader(true);
        const contractAddress = environment?.StackContact;
        const contract = getStackContract(contractAddress, web3);
        try {
          settext("Confirm Claim Transaction And Wait...");
          setMainLoader(true);
          var gasFunPrice;
          web3.eth.getGasPrice().then((result) => {
            var result2 = parseInt(result) + 3000000000;
            gasFunPrice = result2.toString();
          });
          const gas = await contract.methods
            .claim()
            .estimateGas({ from: account });
          const gaslimit = gas + parseInt(15000);
          const balance = await contract.methods
            .claim()
            .send({ from: account, gas: gaslimit, gasPrice: gasFunPrice });
          if (balance) {
            setTimeout(() => {
              getBalance();
              DopBalanceCheck();
              getClaimeduserdata();
              handleClose6();
              handleShow7();
              setMainLoader(false);
              settext("Loading...");
              ClaimableRewarCheck();
            }, 1000);
          }
        } catch (error) {
          setMainLoader(false);
          settext("Loading...");
          if (error.code === -32000) {
            seterrormessage("Insufficient Eth For Fee");
            handleShow13();
            // toast.warning("Insufficient Eth For Fee", {
            //   position: "top-center",
            //   autoClose: 4000,
            // });
            console.log("9999999", typeof error.code);
            throw error;
          } else {
            seterrormessage(error.message);
            handleShow13();
            // toast.error(error.message, {
            //   position: "top-center",
            //   autoClose: 4000,
            // });
            console.log("9999999", error);
            throw error;
          }
        }
      } catch {
        // setMainLoader(false);
      }
    } else {
      seterrormessage("Please Connect Your Wallet First");
      handleShow13();
      // toast.error("Please Connect Your Wallet First", {
      //   position: "top-center",
      //   autoClose: 5000,
      // });
    }
  };

  const getDepositDataAmount = () => {
    // setMainLoader(true);
    let acc = JSON.stringify(account);
    const first = 1000;
    var data = JSON.stringify({
      query: `query MyQuery {
          stakeds(where: {staker: ${acc}}, first: ${first}) {
            id
          }
        }
      `,
    });
    var config = {
      method: "post",
      url: environment.StackGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        // console.log("sdsdssd", response);
        setActiveDepositCount(response?.data?.data?.stakeds?.length);
        // setMainLoader(false);
      })
      .catch(function (error) {
        // setMainLoader(false);
      });
  };

  const getDepositData = (page = 1, pageSize = 10) => {
    settext("Fetching your staking data....");
    setMainLoader(true);
    let acc = JSON.stringify(account);
    const skip = (page - 1) * pageSize;
    const first = pageSize;

    var data = JSON.stringify({
      query: `query MyQuery {
        stakeds(where: {staker: ${acc}}, first: ${first}, skip: ${skip}, orderBy: blockTimestamp, orderDirection: desc) {
          amount
          claimTime
          blockTimestamp
          staker
          transactionHash
        }
      }`,
    });

    var config = {
      method: "post",
      url: environment.StackGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        setActiveDeposit(response?.data?.data?.stakeds);
        setMainLoader(false);
        settext("Loading...");
      })
      .catch(function (error) {
        setMainLoader(false);
        settext("Loading...");
        console.error(error);
      });
  };

  const getClaimeduserdata = () => {
    let acc = JSON.stringify(account);
    let accounthere = acc.toLocaleLowerCase();

    var data = JSON.stringify({
      query: `query MyQuery {
          stakers(where: {id: ${accounthere}}) {
            totalAmountClaimed
          }
        }`,
    });

    var config = {
      method: "post",
      url: environment.StackGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        // console.log("ammount claimed", response)
        setAmountclamiednow(
          response?.data?.data?.stakers[0]?.totalAmountClaimed
        );
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const DopBalanceCheckTOTAL = async () => {
    // console.log("total");
    const contractAddress = environment?.StackContact;
    const contract = getStackContract(contractAddress, web3);
    try {
      // console.log("total");
      const approved = await contract.methods.totalStaked().call();
      // let balance = parseInt(approved) / 300000000000000000
      // console.log("balance", approved);
      setMyDopBalanceTotalhere(approved / 10 ** 18);
    } catch (error) {
      console.log("error get");
    }
    // setMainLoader(false);
  };

  useEffect(() => {
    if (account) {
      // console.log("value here is++++++++++++++++++++++++++++")

      getBalance();
      StackingAllowenceCheck();
      DopBalanceCheck();
      ClaimableRewarCheck();
      ClaimableRewarChecks();
      getDepositDataAmount();
      getClaimeduserdata();
      DopBalanceCheckTOTAL();
    } else {
      // setBalanceOf(0);
      setMyDopBalance(0);
      setclamiedreward(0);
      setActiveDeposit([]);
      setAmountclamiednow(0);
      setActiveDepositCount(0);
      setMyDopBalanceactive(0);
      setRestakedvalue(0);
    }
  }, [account]);

  // console.log("account", account)

  const toasterrormodal = () => {
    handleShow11();
  };
  const toasterrormodals = () => {
    handleShow12();
  };

  const toasterrormodalss = () => {
    handleShow8();
  };

  const calculateTimeLeft = () => {
    const currentTime = Math.floor(Date.now() / 1000);
    const timeLeft = claimabletime - currentTime + 10; // Added 10 seconds here
    return Math.max(timeLeft, 0);
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    // Update the timer every second
    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();

      if (newTimeLeft <= 0) {
        clearInterval(interval);
        setTimeIsUp(true);
      }

      setTimeLeft(newTimeLeft);
    }, 1000);

    return () => clearInterval(interval);
  }, [claimabletime, calculateTimeLeft()]);

  useEffect(() => {
    if (openmodal === true) {
      handleShow();
    }
  }, [openmodal]);

  // Function to format time
  const formatTime = (seconds) => {
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= 24 * 3600;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    return (
      <>
        <h5>Claim Available in</h5>
        <h6 className="mt-1">
          {days || 0}D:{hours || 0}H:{minutes || 0}M:{seconds || 0}S
        </h6>
      </>
    );
  };

  // const StakeFunGas = async () => {
  //   const contractAddress = environment?.StackContact;
  //   const contract = getStackContract(contractAddress, web3);
  //   const chainId = process.env.REACT_APP_NODE_1;
  //   const web3Gas = new Web3(new Web3.providers.HttpProvider(chainId));
  //   const gasP = await web3Gas.eth.getGasPrice();
  //   const gasPWei = parseInt(gasP) / 10 ** 9;

  //   try {
  //     let nd = web3.utils.toWei(valueamount.toString(), "ether");

  //     const gas = await contract.methods
  //       .stake(nd?.toString())
  //       .estimateGas({ from: account });

  //     const gf = parseInt(gas.toString()) / 10 ** 9;

  //     // Calculate additional 10 gwei in wei
  //     const additionalGasFeeGwei = 3000000000;
  //     // const additionalGasFeeWei = additionalGasFeeGwei * 10 ** 9;

  //     // Add the additional gas fee
  //     const totalGasFeeWei = (parseInt(gas.toString()) + additionalGasFeeGwei);
  //     const finalGasFee = (totalGasFeeWei / 10 ** 9) * gasPWei;

  //     console.log("value here ", finalGasFee);
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const stakeFunc = () => {
    // console.log("here is")
    if (valueamount <= "" || valueamount === undefined || valueamount <= 0) {
      seterrormessage("Enter amount must be greater than 0");
      handleShow13();
      // toast.error("Enter amount must be greater then 0", {
      //   position: "top-center",
      //   autoClose: 5000,
      // });
    } else {
      handleShow1();
      handleClose("stake");
    }
  };

  const unstakeFunc = () => {
    // console.log("here is")
    if (valueamount1 <= "" || valueamount1 === undefined || valueamount1 <= 0) {
      seterrormessage("Enter amount must be greater than 0");
      handleShow13();
      // toast.error("Enter amount must be greater then 0", {
      //   position: "top-center",
      //   autoClose: 5000,
      // });
    } else {
      handleShow4();
      handleClose3("unstake");
    }
  };

  // console.log("value", valueamount1)

  const [show15, setShow15] = useState(false);

  const handleClose15 = () => setShow15(false);
  const handleShow15 = () => setShow15(true);
  return (
    <>
      {mainLoader && <Loader text={text} />}

      <section className="mystaking">
        <div className="custom-container paddmobilezero p-0">
          {/* <h5 className="mystakinghead">My Staking Stats</h5> */}
          {account ? (
            <div className="mystakingmain">
              <div className="leftstaking">
                <h5 className="leftstakinghead">MY DOP STAKING</h5>
                <div className="outerbox">
                  <div className="stakingdetailmain">
                    <div className="stakingdetailinner">
                      <p className="stakingdetailpara">DOP Staked</p>
                      <h6 className="stakingdetailhead">
                        {MyDopBalanceactive
                          ? parseFloat(MyDopBalanceactive).toLocaleString()
                          : 0}{" "}
                        DOP
                      </h6>
                    </div>
                    <div className="stakingdetailinner">
                      <p className="stakingdetailpara">Claimed Rewards</p>
                      <h6 className="stakingdetailhead">
                        {Amountclamiednow
                          ? parseFloat(
                            Amountclamiednow / 10 ** 18
                          ).toLocaleString()
                          : 0}{" "}
                        DOP
                      </h6>
                    </div>
                  </div>
                  {/* <div className="rewardsmain"> */}
                  {/* <div className="rewardsleft">
                  <p className="rewardleftpara">Claimable RewardS</p>
                  <h6 className="rewardlefthead">
                    {clamiedreward ? clamiedreward : 0} DOP
                  </h6>
                </div>
                <div className="rewardsright">
                  {clamiedreward > 0 ? (
                    <button onClick={handleShow9} className="restakebtn">
                      Restake
                    </button>
                  ) : (
                    <button
                      onClick={toasterrormodal}
                      className="restakebtn sdjsgdfhsdgfh"
                    >
                      Restake
                    </button>
                  )}

                  {clamiedreward > 0 ? (
                    <button onClick={handleShow6} className="claimbtn">
                      Claim
                    </button>
                  ) : (
                    <button
                      onClick={toasterrormodals}
                      className="claimbtn sdjsgdfhsdgfh"
                    >
                      Claim
                    </button>
                  )}
                </div> */}

                  {/* <div className="rewardsrightparas">
                  <p className="yellowpara">Next Claim In</p>
                  <p className="yellowhead">70D:32H:47M:12S</p>
                </div> */}
                  {/* </div> */}
                  <div className="newbox">
                    <div className="parentbox">
                      <div className="left">
                        <h6>Claimable Rewards</h6>
                        <p className="sjdasjashdjasdjgsa">
                          {clamiedreward
                            ? parseFloat(clamiedreward).toLocaleString()
                            : 0}{" "}
                          DOP{" "}
                        </p>
                      </div>
                      <div className="left">
                        <h6>DOP restaked</h6>
                        <p className="sjdasjashdjasdjgsa">
                          {Restakedvalue
                            ? parseFloat(Restakedvalue).toLocaleString()
                            : 0}{" "}
                          DOP
                        </p>
                      </div>
                    </div>
                    <div className="endbtnsssss">
                      {/* <div className="timersss">
                    <h6>Claimable in</h6>
                    <p>70D:32H:47M:12S</p>
                  </div> */}

                      {clamiedreward > 0 ? (
                        <>
                          {timeIsUp ? (
                            <button onClick={handleShow6} className="claimssssss">
                              Claim
                            </button>
                          ) : (
                            <button className="claimssssss jhcbdshjbchbdshc">
                              {formatTime(timeLeft)}
                            </button>
                          )}
                        </>
                      ) : (
                        <button
                          onClick={toasterrormodals}
                          className="claimssssss"
                        >
                          Claim
                        </button>
                      )}

                      {clamiedreward > 0 ? (
                        <>
                          {/* <button onClick={handleShow9} className="staksssss">
                        Restake
                      </button> */}

                          <div className="disabledmain">
                            <button
                              onClick={() => {
                                if (window.innerWidth < 992) {
                                  handleShow15();
                                }
                              }}
                              className="staksssssbtn"
                            >
                              Restake
                            </button>

                            <div className="disableinner leftset">
                              Staking is temporarily unavailable due to an upcoming migration. <a href="https://dop.org/dop-token" target="_blank">Learn more</a>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {/* <button onClick={toasterrormodal} className="staksssss">
                         Restake
                       </button> */}

                          <div className="disabledmain">
                            <button
                              onClick={() => {
                                if (window.innerWidth < 992) {
                                  handleShow15();
                                }
                              }}
                              className="staksssssbtn"
                            >
                              Restake
                            </button>

                            <div className="disableinner leftset">
                              Staking is temporarily unavailable due to an upcoming migration. <a href="https://dop.org/dop-token" target="_blank">Learn more</a>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="twice-btn">
                    {account ? (
                      <button onClick={handleShow3} className="unstakebtn">
                        Unstake
                      </button>
                    ) : (
                      <button onClick={toasterrormodalss} className="unstakebtn">
                        Unstake
                      </button>
                    )}
                    {account ? (
                      <>
                        {/* <button onClick={handleShow} className="stakebtn">
                      Stake
                    </button> */}
                        <div className="disabledmain">
                          <button
                            onClick={() => {
                              if (window.innerWidth < 992) {
                                handleShow15();
                              }
                            }}
                            className="disabledstakebtn"
                          >
                            Stake
                          </button>

                          <div className="disableinner">
                            Staking is temporarily unavailable due to an upcoming migration. <a href="https://dop.org/dop-token" target="_blank">Learn more</a>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* <button onClick={toasterrormodalss} className="stakebtn">
                      Stake
                    </button> */}
                        <div className="disabledmain">
                          <button
                            onClick={() => {
                              if (window.innerWidth < 992) {
                                handleShow15();
                              }
                            }}
                            className="disabledstakebtn"
                          >
                            Stake
                          </button>

                          <div className="disableinner">
                            Staking is temporarily unavailable due to an upcoming migration. <a href="https://dop.org/dop-token" target="_blank">Learn more</a>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="rightstaking">
                <h5 className="rightstakinghead">My ACTIVITY</h5>

                <StakingTable
                  indexwait={indexwait}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  indexwaits={indexwaits}
                  activeDepositCount={activeDepositCount}
                  activeDeposit={activeDeposit}
                  account={account}
                  getDepositData={getDepositData}
                />
              </div>
            </div>
          ) : (
            <div className="stakingstatbox">
              <div className="wrapper">
                <h6>You haven't connected your wallet yet.</h6>
                <p className="whitetext">
                  Click here to connect your wallet.{" "}
                </p>
                <button
                  className="waletconnectss"
                  onClick={() => {
                    setShow111(true);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path d="M14.667 11.667H14.677" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.33333 5.83333H16.3333C16.7754 5.83333 17.1993 6.00893 17.5118 6.32149C17.8244 6.63405 18 7.05797 18 7.5V15.8333C18 16.2754 17.8244 16.6993 17.5118 17.0118C17.1993 17.3244 16.7754 17.5 16.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V4.16667C3 3.72464 3.17559 3.30072 3.48816 2.98816C3.80072 2.67559 4.22464 2.5 4.66667 2.5H16.3333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>Connect Wallet
                </button>
              </div>
            </div>
          )}

          {/* connect wallet screen  */}
        </div>
      </section>

      <Modal
        className="generic-modal stakingmodals"
        show={show}
        onHide={handleClose}
        centered
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Stake</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="stakecard">
            <div className="textcard">
              <div className="parent">
                <h4 className="uppertext">Enter $DOP amount to stake</h4>
                <p className="para">1,254.56</p>
                <input
                  onChange={handleInputChange}
                  value={valueamount}
                  type="text"
                  placeholder="0.00"
                  pattern="\d*\.?\d*"
                />
                <h6 onClick={handleMaxBal} className="max">
                  MAX
                </h6>
              </div>
            </div>
          </div> */}
          <div className="newstakecard">
            <div className="upper-box">
              <h6>Enter $DOP amount to stake</h6>
              {/* <h6><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path d="M15.1875 5H3.9375C3.78832 5 3.64524 4.94074 3.53975 4.83525C3.43426 4.72976 3.375 4.58668 3.375 4.4375C3.375 4.28832 3.43426 4.14524 3.53975 4.03975C3.64524 3.93426 3.78832 3.875 3.9375 3.875H13.5C13.6492 3.875 13.7923 3.81574 13.8977 3.71025C14.0032 3.60476 14.0625 3.46168 14.0625 3.3125C14.0625 3.16332 14.0032 3.02024 13.8977 2.91475C13.7923 2.80926 13.6492 2.75 13.5 2.75H3.9375C3.48995 2.75 3.06072 2.92779 2.74426 3.24426C2.42779 3.56072 2.25 3.98995 2.25 4.4375V13.4375C2.25 13.8851 2.42779 14.3143 2.74426 14.6307C3.06072 14.9472 3.48995 15.125 3.9375 15.125H15.1875C15.4859 15.125 15.772 15.0065 15.983 14.7955C16.194 14.5845 16.3125 14.2984 16.3125 14V6.125C16.3125 5.82663 16.194 5.54048 15.983 5.3295C15.772 5.11853 15.4859 5 15.1875 5ZM15.1875 14H3.9375C3.78832 14 3.64524 13.9407 3.53975 13.8352C3.43426 13.7298 3.375 13.5867 3.375 13.4375V6.02867C3.55562 6.0927 3.74587 6.12528 3.9375 6.125H15.1875V14ZM11.8125 9.78125C11.8125 9.61437 11.862 9.45124 11.9547 9.31249C12.0474 9.17373 12.1792 9.06559 12.3334 9.00173C12.4875 8.93787 12.6572 8.92116 12.8209 8.95371C12.9845 8.98627 13.1349 9.06663 13.2529 9.18463C13.3709 9.30263 13.4512 9.45297 13.4838 9.61664C13.5163 9.78031 13.4996 9.94996 13.4358 10.1041C13.3719 10.2583 13.2638 10.3901 13.125 10.4828C12.9863 10.5755 12.8231 10.625 12.6562 10.625C12.4325 10.625 12.2179 10.5361 12.0596 10.3779C11.9014 10.2196 11.8125 10.005 11.8125 9.78125Z" fill="#212121" />
              </svg>21,552.887 DOP</h6> */}
            </div>
            <div className="bottom-box">
              <div className="option-field">
                <input
                  onChange={handleInputChange}
                  value={valueamount}
                  type="text"
                  placeholder="0.00"
                  pattern="\d*\.?\d*"
                />
                <a onClick={handleMaxBal} className="btn-max">MAX</a>
              </div>
              <div className="token-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                  <rect y="0.5" width="22" height="22" rx="11" fill="#171717" />
                  <path d="M5 5.5H11.3333C13.1014 5.5 14.7971 6.18482 16.0474 7.40381C17.2976 8.62279 18 10.2761 18 12C18 13.7239 17.2976 15.3772 16.0474 16.5962C14.7971 17.8152 13.1014 18.5 11.3333 18.5V15.1676C12.195 15.1676 13.0213 14.8339 13.6306 14.2398C14.2399 13.6458 14.5822 12.8401 14.5822 12C14.5822 11.1599 14.2399 10.3542 13.6306 9.76016C13.0213 9.16612 12.195 8.83239 11.3333 8.83239V8.83333H8V11.8333H5V5.5Z" fill="white" />
                  <path d="M8 11.8333L11.3333 11.8333V15.1667H8L8 11.8333Z" fill="white" />
                </svg> <h6>DOP</h6>
              </div>
            </div>
          </div>
          <div className="textparent">
            <div className="innercontent">
              <h6 className="wallet">Wallet Balance</h6>
              <p className="textpara">
                {balanceOf ? parseFloat(balanceOf).toLocaleString() : 0} DOP
              </p>
            </div>
            <div className="innercontent">
              <h6 className="wallet">Reward APY %</h6>
              <p className="textpara">
                {apy && MyDopBalanceTotalhere
                  ? parseFloat(apy).toFixed(2)
                  : 23000.0}
                %
              </p>
            </div>
            {/* <div className="innercontent">
              <h6 className="wallet">Transaction Fee</h6>
              <p className="textpara">--</p>
            </div> */}
          </div>
          <div className="mainbtns">
            <button
              onClick={() => {
                handleClose();
              }}
              className="dullbtn"
            >
              Close
            </button>
            {/* diabledbtn */}
            <button
              className="brdrbtn"
              onClick={() => {
                stakeFunc();
                // handleShow1();
                // handleClose("stake");
                // StakeFunGas();
                // StakeFun();
              }}
            >
              Stake
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <div>
            <h6>Transaction Summary</h6>
            <p>Please confirm your transaction details</p>
          </div>
        </Modal.Header>
        <Modal.Body style={{ borderTop: "1px solid #f0f0f0" }}>
          {/* <div className="stakecard ">
            <div className="textcard ">
              <div className="parent">
                <h4 className="uppertext">Staking Amount</h4>
                <p className="para">
                  {valueamount ? parseFloat(valueamount).toFixed(5) : 0}
                </p>
              </div>
            </div>
          </div> */}
          <div className="textparent" style={{ marginBottom: "25px" }}>
            <div className="innercontent">
              <h6 className="wallet">Staking Amount</h6>
              <p className="textpara">{valueamount ? parseFloat(valueamount).toFixed(5) : 0}</p>
            </div>
            <div className="innercontent">
              <h6 className="wallet">Wallet Balance</h6>
              <p className="textpara">{balanceOf ? balanceOf : 0} DOP</p>
            </div>
            <div className="innercontent">
              <h6 className="wallet">Reward APY %</h6>
              <p className="textpara">
                {apy && MyDopBalanceTotalhere
                  ? parseFloat(apy).toFixed(2)
                  : 23000.0}
                %
              </p>
            </div>
            {/* <div className="innercontent">
              <h6 className="wallet">Transaction Fee</h6>
              <p className="textpara">$8.522 (0.01 ETH)</p>
            </div> */}
          </div>
          <div className="mainbtns">
            <button
              onClick={() => {
                handleClose1();
              }}
              className="dullbtn"
            >
              Cancel
            </button>
            <button
              className="brdrbtn"
              onClick={() => {
                // handleShow1();
                // handleClose();
                StakeFun();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <img src="\assets\modalshadowgreen.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Stake</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\happy.png"
              alt="img"
              className="img-fluid formsrgin"
              style={{ marginTop: "10px" }}
            />
            <h6 style={{ marginTop: "30px", color: "#27A57F", fontSize: "18px" }}>Staked successfully</h6>
            <h5><svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
              <path d="M18 0.5C27.942 0.5 36 8.55958 36 18.5C36 28.442 27.942 36.5 18 36.5C8.05958 36.5 0 28.4412 0 18.5C0 8.55958 8.05958 0.5 18 0.5Z" fill="#131313" />
              <path d="M10.4473 9.82275H18.9025C21.263 9.82275 23.5268 10.737 25.1959 12.3644C26.865 13.9918 27.8027 16.199 27.8027 18.5005C27.8027 20.802 26.865 23.0092 25.1959 24.6366C23.5268 26.264 21.263 27.1782 18.9025 27.1782V22.7294C20.0528 22.7294 21.156 22.2838 21.9694 21.4908C22.7828 20.6977 23.2398 19.6221 23.2398 18.5005C23.2398 17.3789 22.7828 16.3033 21.9694 15.5102C21.156 14.7172 20.0528 14.2716 18.9025 14.2716V14.2729H14.4524V18.278H10.4473V9.82275Z" fill="white" />
              <rect x="14.4558" y="18.2964" width="4.4085" height="4.4085" fill="white" />
            </svg>{stakedvalue ? parseFloat(stakedvalue).toFixed(5) : 0} <span>DOP</span></h5>
            <button className="commonbtn" onClick={handleClose2} style={{ background: "rgba(215, 230, 238, 0.20)", border: "1px solid #EDF3F7" }}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Unstake</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="newstakecard">
            <div className="upper-box">
              <h6>Enter $DOP amount to Unstake</h6>
              {/* <h6><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path d="M15.1875 5H3.9375C3.78832 5 3.64524 4.94074 3.53975 4.83525C3.43426 4.72976 3.375 4.58668 3.375 4.4375C3.375 4.28832 3.43426 4.14524 3.53975 4.03975C3.64524 3.93426 3.78832 3.875 3.9375 3.875H13.5C13.6492 3.875 13.7923 3.81574 13.8977 3.71025C14.0032 3.60476 14.0625 3.46168 14.0625 3.3125C14.0625 3.16332 14.0032 3.02024 13.8977 2.91475C13.7923 2.80926 13.6492 2.75 13.5 2.75H3.9375C3.48995 2.75 3.06072 2.92779 2.74426 3.24426C2.42779 3.56072 2.25 3.98995 2.25 4.4375V13.4375C2.25 13.8851 2.42779 14.3143 2.74426 14.6307C3.06072 14.9472 3.48995 15.125 3.9375 15.125H15.1875C15.4859 15.125 15.772 15.0065 15.983 14.7955C16.194 14.5845 16.3125 14.2984 16.3125 14V6.125C16.3125 5.82663 16.194 5.54048 15.983 5.3295C15.772 5.11853 15.4859 5 15.1875 5ZM15.1875 14H3.9375C3.78832 14 3.64524 13.9407 3.53975 13.8352C3.43426 13.7298 3.375 13.5867 3.375 13.4375V6.02867C3.55562 6.0927 3.74587 6.12528 3.9375 6.125H15.1875V14ZM11.8125 9.78125C11.8125 9.61437 11.862 9.45124 11.9547 9.31249C12.0474 9.17373 12.1792 9.06559 12.3334 9.00173C12.4875 8.93787 12.6572 8.92116 12.8209 8.95371C12.9845 8.98627 13.1349 9.06663 13.2529 9.18463C13.3709 9.30263 13.4512 9.45297 13.4838 9.61664C13.5163 9.78031 13.4996 9.94996 13.4358 10.1041C13.3719 10.2583 13.2638 10.3901 13.125 10.4828C12.9863 10.5755 12.8231 10.625 12.6562 10.625C12.4325 10.625 12.2179 10.5361 12.0596 10.3779C11.9014 10.2196 11.8125 10.005 11.8125 9.78125Z" fill="#212121" />
              </svg>21,552.887 DOP</h6> */}
            </div>
            <div className="bottom-box">
              <div className="option-field">
                <input
                  onChange={handleInputChange1}
                  value={valueamount1}
                  type="text"
                  placeholder="0.00"
                  pattern="\d*\.?\d*"
                />
                <a onClick={handleMaxBal1} className="btn-max">MAX</a>
              </div>
              <div className="token-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                  <rect y="0.5" width="22" height="22" rx="11" fill="#171717" />
                  <path d="M5 5.5H11.3333C13.1014 5.5 14.7971 6.18482 16.0474 7.40381C17.2976 8.62279 18 10.2761 18 12C18 13.7239 17.2976 15.3772 16.0474 16.5962C14.7971 17.8152 13.1014 18.5 11.3333 18.5V15.1676C12.195 15.1676 13.0213 14.8339 13.6306 14.2398C14.2399 13.6458 14.5822 12.8401 14.5822 12C14.5822 11.1599 14.2399 10.3542 13.6306 9.76016C13.0213 9.16612 12.195 8.83239 11.3333 8.83239V8.83333H8V11.8333H5V5.5Z" fill="white" />
                  <path d="M8 11.8333L11.3333 11.8333V15.1667H8L8 11.8333Z" fill="white" />
                </svg> <h6>DOP</h6>
              </div>
            </div>
          </div>
          <div className="textparent">
            <div className="innercontent">
              <h6 className="wallet">Available to Unstake</h6>
              <p className="textpara">{MyDopBalance ? MyDopBalance : 0} DOP</p>
            </div>
            {/* <div className="innercontent">
              <h6 className="wallet">Transaction Fee</h6>
              <p className="textpara">--</p>
            </div> */}
          </div>
          <div className="mainbtns">
            <button
              onClick={() => {
                handleClose3();
              }}
              className="dullbtn"
            >
              Close
            </button>
            <button
              className="brdrbtn"
              onClick={() => {
                unstakeFunc();
              }}
            >
              Unstake
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show4}
        onHide={handleClose4}
        centered
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <div>
            <h6>Transaction Summary</h6>
            <p>Please confirm your transaction details</p>
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="stakecard ">
            <div className="textcard">
              <div className="parent">
                <h4 className="uppertext">Unstaking Amount</h4>
                <p className="para">
                  {valueamount1 ? parseFloat(valueamount1).toFixed(5) : 0}
                </p>
              </div>
            </div>
          </div> */}
          <div className="textparent">
            <div className="innercontent">
              <h6 className="wallet">Unstaking Amount</h6>
              <p className="textpara">{valueamount1 ? parseFloat(valueamount1).toFixed(5) : 0}</p>
            </div>
            <div className="innercontent">
              <h6 className="wallet">Available to Unstake</h6>
              <p className="textpara">{MyDopBalance ? MyDopBalance : 0} DOP</p>
            </div>
            {/* <div className="innercontent">
              <h6 className="wallet">Transaction Fee</h6>
              <p className="textpara">$8.522 (0.01 ETH)</p>
            </div> */}
          </div>
          <div className="yellowbox">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M11 17.531H13V11.531H11V17.531ZM12 9.53101C12.2833 9.53101 12.521 9.43501 12.713 9.24301C12.905 9.05101 13.0007 8.81367 13 8.53101C12.9993 8.24834 12.9033 8.01101 12.712 7.81901C12.5207 7.62701 12.2833 7.53101 12 7.53101C11.7167 7.53101 11.4793 7.62701 11.288 7.81901C11.0967 8.01101 11.0007 8.24834 11 8.53101C10.9993 8.81367 11.0953 9.05134 11.288 9.24401C11.4807 9.43667 11.718 9.53234 12 9.53101ZM12 22.531C10.6167 22.531 9.31667 22.2683 8.1 21.743C6.88334 21.2177 5.825 20.5053 4.925 19.606C4.025 18.7067 3.31267 17.6483 2.788 16.431C2.26333 15.2137 2.00067 13.9137 2 12.531C1.99933 11.1483 2.262 9.84834 2.788 8.63101C3.314 7.41367 4.02633 6.35534 4.925 5.45601C5.82367 4.55667 6.882 3.84434 8.1 3.31901C9.318 2.79367 10.618 2.53101 12 2.53101C13.382 2.53101 14.682 2.79367 15.9 3.31901C17.118 3.84434 18.1763 4.55667 19.075 5.45601C19.9737 6.35534 20.6863 7.41367 21.213 8.63101C21.7397 9.84834 22.002 11.1483 22 12.531C21.998 13.9137 21.7353 15.2137 21.212 16.431C20.6887 17.6483 19.9763 18.7067 19.075 19.606C18.1737 20.5053 17.1153 21.218 15.9 21.744C14.6847 22.27 13.3847 22.5323 12 22.531ZM12 20.531C14.2333 20.531 16.125 19.756 17.675 18.206C19.225 16.656 20 14.7643 20 12.531C20 10.2977 19.225 8.40601 17.675 6.85601C16.125 5.30601 14.2333 4.53101 12 4.53101C9.76667 4.53101 7.875 5.30601 6.325 6.85601C4.775 8.40601 4 10.2977 4 12.531C4 14.7643 4.775 16.656 6.325 18.206C7.875 19.756 9.76667 20.531 12 20.531Z" fill="#E2970C" />
            </svg>
            <div className="inline-elem">
              <h4 className="cool">cooldown Period</h4>
              <p className="yellowpara">
                After unstaking your DOP, you will be able to withdraw your tokens
                in 7 days
              </p>
            </div>
          </div>
          <div className="mainbtns">
            <button
              onClick={() => {
                handleClose4();
              }}
              className="dullbtn"
            >
              Cancel
            </button>
            <button
              className="brdrbtn"
              onClick={() => {
                // handleShow5();
                // handleClose4();
                UnstakeFun();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show5}
        onHide={handleClose5}
        centered
      >
        <img src="\assets\modalshadowgreen.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Unstaked</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\happy.png"
              alt="img"
              className="img-fluid formsrgin"
              style={{ marginTop: "10px" }}
            />
            <h6 style={{ marginTop: "30px", color: "#27A57F", fontSize: "18px" }}>Unstaked successfully</h6>
            <h5><svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
              <path d="M18 0.5C27.942 0.5 36 8.55958 36 18.5C36 28.442 27.942 36.5 18 36.5C8.05958 36.5 0 28.4412 0 18.5C0 8.55958 8.05958 0.5 18 0.5Z" fill="#131313" />
              <path d="M10.4473 9.82275H18.9025C21.263 9.82275 23.5268 10.737 25.1959 12.3644C26.865 13.9918 27.8027 16.199 27.8027 18.5005C27.8027 20.802 26.865 23.0092 25.1959 24.6366C23.5268 26.264 21.263 27.1782 18.9025 27.1782V22.7294C20.0528 22.7294 21.156 22.2838 21.9694 21.4908C22.7828 20.6977 23.2398 19.6221 23.2398 18.5005C23.2398 17.3789 22.7828 16.3033 21.9694 15.5102C21.156 14.7172 20.0528 14.2716 18.9025 14.2716V14.2729H14.4524V18.278H10.4473V9.82275Z" fill="white" />
              <rect x="14.4558" y="18.2964" width="4.4085" height="4.4085" fill="white" />
            </svg>{unstakedvalue ? parseFloat(unstakedvalue).toFixed(5) : 0} <span>DOP</span></h5>
            <button className="commonbtn" onClick={handleClose5} style={{ background: "rgba(215, 230, 238, 0.20)", border: "1px solid #EDF3F7" }}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show6}
        onHide={handleClose6}
        centered
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Claim Rewards</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="stakecard" style={{ marginBottom: "25px" }}>
            <div className="textcard">
              <div className="parent">
                <h4 className="uppertext">Claimable Reward</h4>
                {/* {timeIsUp ? ( */}
                <p className="para">{clamiedreward ? clamiedreward : 0} DOP</p>
                {/* // <button  className="btn-claim">
                  //   Claim HYGT
                  // </button>
                ) : (
                  <p className="sdsdfadsfdsfsdf para">{formatTime(timeLeft)}</p>
                )} */}
              </div>
            </div>
          </div>

          <div className="mainbtns">
            <button
              onClick={() => {
                handleClose6();
              }}
              className="dullbtn"
            >
              Cancel
            </button>
            {timeIsUp === true ? (
              <button
                className="brdrbtn"
                onClick={() => {
                  // handleShow7();
                  // handleClose6();
                  claimFun();
                }}
              >
                Claim
              </button>
            ) : (
              <button className="brdrbtn buttonblur">Claim</button>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show7}
        onHide={handleClose7}
        centered
      >
        <img src="\assets\modalshadowgreen.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Claim Rewards</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\happy.png"
              alt="img"
              className="img-fluid formsrgin"
              style={{ marginTop: "10px" }}
            />
            <h6 style={{ marginTop: "30px", color: "#27A57F", fontSize: "18px" }}>Claimed successfully</h6>
            <h5><svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
              <path d="M18 0.5C27.942 0.5 36 8.55958 36 18.5C36 28.442 27.942 36.5 18 36.5C8.05958 36.5 0 28.4412 0 18.5C0 8.55958 8.05958 0.5 18 0.5Z" fill="#131313" />
              <path d="M10.4473 9.82275H18.9025C21.263 9.82275 23.5268 10.737 25.1959 12.3644C26.865 13.9918 27.8027 16.199 27.8027 18.5005C27.8027 20.802 26.865 23.0092 25.1959 24.6366C23.5268 26.264 21.263 27.1782 18.9025 27.1782V22.7294C20.0528 22.7294 21.156 22.2838 21.9694 21.4908C22.7828 20.6977 23.2398 19.6221 23.2398 18.5005C23.2398 17.3789 22.7828 16.3033 21.9694 15.5102C21.156 14.7172 20.0528 14.2716 18.9025 14.2716V14.2729H14.4524V18.278H10.4473V9.82275Z" fill="white" />
              <rect x="14.4558" y="18.2964" width="4.4085" height="4.4085" fill="white" />
            </svg>{clamiedrewardss ? clamiedrewardss : 0} <span>DOP</span></h5>
            <button className="commonbtn" onClick={handleClose7} style={{ background: "rgba(215, 230, 238, 0.20)", border: "1px solid #EDF3F7" }}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show8}
        onHide={handleClose8}
        centered
      >
        <img src="\assets\modalshadowerror.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Wallet Connect</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\vector.png"
              alt="img"
              className="img-fluid 
formsrgin"
            />
            <p className="wrong" style={{ color: "#BF3436", fontSize: "18px", fontWeight: "500", textTransform: "capitalize" }}>Please Connect Your Wallet First</p>

            <button className="commonbtn" onClick={handleClose8}>
              Try Again
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show13}
        onHide={handleClose13}
        centered
      >
        <img src="\assets\modalshadowerror.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\vector.png"
              alt="img"
              className="img-fluid 
formsrgin"
            />

            <p className="wrong" style={{ color: "#BF3436", fontSize: "18px", fontWeight: "500", textTransform: "capitalize" }}>{errormessage ? errormessage : "no error"}</p>
            <button className="commonbtn" onClick={handleClose13}>
              Try again
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show9}
        onHide={handleClose9}
        centered
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Restake</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="stakecard ">
            <div className="textcard">
              <div className="parent">
                <h4 className="uppertext">Available DOP</h4>
                <p className="para">{clamiedreward ? clamiedreward : 0} DOP</p>
              </div>
            </div>
          </div>

          <div className="yellowbox">
            <div className="inline-elem">
              <h4 className="cool">Lockup Period</h4>
              <p className="yellowpara">
                Restaking your rewards will reset your lockup period to 90 days.
              </p>
            </div>
          </div>
          <div className="mainbtns">
            <button
              onClick={() => {
                handleClose9();
              }}
              className="dullbtn"
            >
              Cancel
            </button>
            <button
              className="brdrbtn"
              onClick={() => {
                // handleShow10();
                // handleClose9();
                RestateFun();
              }}
            >
              Restake
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show10}
        onHide={handleClose10}
        centered
      >
        <img src="\assets\modalshadowgreen.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Restake</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\happy.png"
              alt="img"
              className="img-fluid formsrgin"
              style={{ marginTop: "10px" }}
            />
            <h6 style={{ marginTop: "30px", color: "#27A57F", fontSize: "18px" }}>Restaked successfully</h6>
            <h5><svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
              <path d="M18 0.5C27.942 0.5 36 8.55958 36 18.5C36 28.442 27.942 36.5 18 36.5C8.05958 36.5 0 28.4412 0 18.5C0 8.55958 8.05958 0.5 18 0.5Z" fill="#131313" />
              <path d="M10.4473 9.82275H18.9025C21.263 9.82275 23.5268 10.737 25.1959 12.3644C26.865 13.9918 27.8027 16.199 27.8027 18.5005C27.8027 20.802 26.865 23.0092 25.1959 24.6366C23.5268 26.264 21.263 27.1782 18.9025 27.1782V22.7294C20.0528 22.7294 21.156 22.2838 21.9694 21.4908C22.7828 20.6977 23.2398 19.6221 23.2398 18.5005C23.2398 17.3789 22.7828 16.3033 21.9694 15.5102C21.156 14.7172 20.0528 14.2716 18.9025 14.2716V14.2729H14.4524V18.278H10.4473V9.82275Z" fill="white" />
              <rect x="14.4558" y="18.2964" width="4.4085" height="4.4085" fill="white" />
            </svg>{clamiedrewardss ? clamiedrewardss : 0} <span>DOP</span></h5>
            <button className="commonbtn" onClick={handleClose10} style={{ background: "rgba(215, 230, 238, 0.20)", border: "1px solid #EDF3F7" }}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show11}
        onHide={handleClose11}
        centered
      >
        <img src="\assets\modalshadowerror.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Restake</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\vector.png"
              alt="img"
              className="img-fluid formsrgin"
            />
            <h5 className="sjdgsdhjgdsjf text-center mb-3" style={{ fontSize: "20px", marginTop: "30px" }}>
              There are Two possible cases for having a Claimable Rewards
              balance of 0:
            </h5>
            <ol>
              {/* <li className="wrong sjdgsdhjgdsjf">If you have not staked any DOP coins, you need to stake DOP first.</li>
              <li className="wrong sjdgsdhjgdsjf">If you have already claimed all of your claimable rewards, you need to stake again to earn more rewards.</li> */}
              <li className="wrong sjdgsdhjgdsjf my-3">
                If you have just restaked, wait 1 minutes for your rewards to
                start generating automatically.
              </li>
              <li className="wrong sjdgsdhjgdsjf my-3">
                If your wallet is not connected then please connect your wallet
                first.
              </li>
            </ol>
            {/* <p className="wrong"></p> */}
            <button className="commonbtn" onClick={handleClose11}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show12}
        onHide={handleClose12}
        centered
      >
        <img src="\assets\modalshadowerror.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Claim</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\vector.png"
              alt="img"
              className="img-fluid formsrgin"
            />
            <h5 className="sjdgsdhjgdsjf text-center mb-3" style={{ fontSize: "20px", marginTop: "30px" }}>
              There are three possible cases for having a Claimable Rewards
              balance of 0:
            </h5>
            <ol>
              <li className="wrong sjdgsdhjgdsjf my-3">
                If you have not staked any DOP coins, you need to stake DOP
                first your reward will update every 1 minute.
              </li>
              <li className="wrong sjdgsdhjgdsjf my-3">
                If you have already claimed all of your claimable rewards, you
                need to stake again to earn more rewards.
              </li>
              <li className="wrong sjdgsdhjgdsjf my-3">
                If your wallet is not connected then please connect your wallet
                first.
              </li>
              {/* <li className="wrong sjdgsdhjgdsjf">If you have just restaked, wait 5 minutes for your rewards to start generating automatically.</li> */}
            </ol>
            {/* <p className="wrong"></p> */}
            <button className="commonbtn" onClick={handleClose12}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Offcanvas
        show={show15}
        onHide={handleClose15}
        className="mobilestakingsidebar"
        placement="bottom"
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Offcanvas.Header>
          <Offcanvas.Title>Stake</Offcanvas.Title>
          <button className="btnclose" onClick={handleClose15}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12 23.25C6.07 23.25 1.25 18.43 1.25 12.5C1.25 6.57 6.07 1.75 12 1.75C17.93 1.75 22.75 6.57 22.75 12.5C22.75 18.43 17.93 23.25 12 23.25ZM12 3.25C6.9 3.25 2.75 7.4 2.75 12.5C2.75 17.6 6.9 21.75 12 21.75C17.1 21.75 21.25 17.6 21.25 12.5C21.25 7.4 17.1 3.25 12 3.25Z"
                fill="#5F5F5F"
              />
              <path
                d="M9.16986 16.08C8.97986 16.08 8.78986 16.01 8.63986 15.86C8.34986 15.57 8.34986 15.09 8.63986 14.8L14.2999 9.13999C14.5899 8.84999 15.0699 8.84999 15.3599 9.13999C15.6499 9.42999 15.6499 9.90998 15.3599 10.2L9.69986 15.86C9.55986 16.01 9.35986 16.08 9.16986 16.08Z"
                fill="#5F5F5F"
              />
              <path
                d="M14.8299 16.08C14.6399 16.08 14.4499 16.01 14.2999 15.86L8.63986 10.2C8.34986 9.90998 8.34986 9.42999 8.63986 9.13999C8.92986 8.84999 9.40986 8.84999 9.69986 9.13999L15.3599 14.8C15.6499 15.09 15.6499 15.57 15.3599 15.86C15.2099 16.01 15.0199 16.08 14.8299 16.08Z"
                fill="#5F5F5F"
              />
            </svg>
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p className="disablepara">
           Staking is temporarily unavailable due to an upcoming migration. 
          </p>
          <a href="https://dop.org/dop-token" target="_blank" className="whitebtn">Learn more</a>
          <button onClick={handleClose15} className="greybtn">
            close
          </button>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Mystaking;
